import React from 'react';
import { withRouter } from 'react-router-dom';
import { store } from '../../store';
import connectWithStore from '../../utils/store'

import Accordion from 'react-bootstrap/Accordion'
import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'
const kennitala = require('kennitala')
import { Link } from 'react-router-dom';
import moment from 'moment';

import { Spinner } from '../../utils'
import { getStepOrder } from '../../constants'

import { SvgArrowIcon, SvgCheckIcon } from '../svg';
import { getQuestionnairesToAnswer, exportQuestionnaireAnswers } from '../../api/questionnaires/actions';
import { fetchTilbod } from '../../api/offers/actions';
import { fetchCustomer, addEmptyCustomer } from '../../api/customers/actions'

import QuestionnaireTemplate from '../../components/questionnaire-template'

import { isUserAdmin } from '../../api/brokers/actions';
import LinkButton from '../link-button'
import { SigningModal } from '../modals'
import { openModal } from '../../api/gui/actions';

// import BaseForm from '../base-form'


class FillQuestionnaire extends React.Component {

	constructor(props) {
		super(props)
		this.state = {
			customerId: props.customerId || "",
			toggledAccordions: {},
			selectedQuestionnaire: props.selectedQuestionnaire || null,
			localQuestionnaires: null,
			localTilbod: props.selectedQuestionnaire ? {contract_files: props.selectedQuestionnaire.contract_files } : null,
            aqModalTitle: "",
            aqModalSigningUrl: "",
			signingStep: 0,
			previousLocation: null,
		}		
		this.infoCollectionComplete = this.infoCollectionComplete.bind(this)
		this.onButtonClick = this.onButtonClick.bind(this)
		this.clippy = this.clippy.bind(this)
		this.goBack = this.goBack.bind(this)
		this.sortQuestionnaires = this.sortQuestionnaires.bind(this);
	}

	componentDidMount() {
		let previousLocation = this.state.previousLocation;
		if (!previousLocation && this.props.location) {
			previousLocation = this.props.location.state
				? this.props.location.state.from
				: null;
			this.setState({ previousLocation });
		}
		if (this.state.customerId.length > 0 && 
			this.state.selectedQuestionnaire) {
			fetch(`/api/v1/additionalquestions/${this.state.selectedQuestionnaire.jsondata.additionalQuestions.questionLists}/`, {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
				},
				credentials: 'include',
			})
			.then(response => response.json())
			.then(data => {
				this.setState({ localQuestionnaires: { isFetching: false, data } });
			});
			return;
		}

		Promise.resolve(this.props.dispatch(fetchTilbod(this.props.match.params.token)))
			.then((response) => {
				this.setState({ customerId: response.jsondata.additionalQuestions.kt })
				this.props.dispatch(getQuestionnairesToAnswer(response.jsondata.additionalQuestions.questionLists))
                this.props.dispatch(fetchCustomer(kennitala.clean(response.jsondata.additionalQuestions.kt)))
			})
			.catch((response) => {
				console.log(JSON.stringify(response))
			})
		this.props.dispatch(isUserAdmin())
	}

	componentDidUpdate() {
		if (this.state.signingStep == 1 && this.props.signingModals && 
			('SigningModal-local' in this.props.signingModals) && 
			!this.props.signingModals['SigningModal-local']) {
			this.setState({signingStep: 2})
			let token = this.props.match.params.token;
			setTimeout(() => this.props.dispatch(fetchTilbod(token, true)),3000);
		}
		if (this.state.signingStep == 2) {
			if (this.props.tilbod.all_signed) {
				this.setState({signingStep: 3})
			}
		}
	}

	infoCollectionComplete(){
		return true
	}

	onButtonClick(key, e){
		const isOpen = this.state.toggledAccordions[key];
		this.setState((prevState) => ({
			toggledAccordions: {
				...prevState.toggledAccordions,
				[key]: !isOpen
			}
		}));
		$(e.target).parents(".card-header").siblings('.collapse').toggleClass('show')
	}

    submitData(paperSigning,genPdf){
        let data = {
            'answers': this.props.questionnaires.answers,
            'nationalRegistry': this.props.nationalRegistry,
            'paperSigning': paperSigning
        }
        Promise.resolve(this.props.dispatch(exportQuestionnaireAnswers(this.props.match.params.token, data, genPdf)))
        .then(response => {
			let token = this.props.match.params.token;
			this.props.dispatch(fetchTilbod(token, true))
			if (genPdf) {
				const contract_file = response.contract_files[0];
				this.setState({
					aqModalTitle: contract_file.description,
					aqModalSigningUrl: contract_file.signing_url,
				});
				this.props.dispatch(openModal("SigningModal-local"))
			}
        })
		if (genPdf) {
			this.setState({signingStep: 1})
		} else if (this.props.offers && this.props.offers.offerQueryParameters) {
			this.goBack(true)
		}
    }

	clippy() {
		let link = document.querySelector('#customer-signing-url');
		link.select()
		document.execCommand('copy');
		window.getSelection().removeAllRanges();
		this.setState({ copied: true })
	}


    backwardButtonText() {
        switch (this.props.currentStep) {
            default:
                return "Til baka"
        }
    }

	goBack(onReturn = false) {
		if (this.state.previousLocation) {
			if (onReturn && this.props.location.state.onReturn) {
				this.props.location.state.onReturn();
			}
			this.props.history.push(this.state.previousLocation)
		} else {
			this.props.history.goBack()
		}
	}

	haveContractFileMessage(all_signed,signingStep) {
		if (signingStep == 1 || signingStep == 2) {
			return "Undirritun í gangi.";
		}
		if (all_signed && signingStep == 3) {
			return "Undirritun lokið."
		}
		if (all_signed) {
			return "Það er þegar búið að fylla út þennan spurningalista og undirrita.";
		}
		return "Það er þegar búið að fylla út þennan spurningalista. Næst er að undirrita" 
	}

	sortQuestionnaires(data) {
        return data.sort((a,b ) => a.title.localeCompare(b.title));
    }


	render() {
		// in case we are in the "tilbod wizard", then we support going back
		let CORRECT_STEP_ORDER = null;
		if (this.props.offers && this.props.offers.offerQueryParameters) {
			 CORRECT_STEP_ORDER = getStepOrder(this.props.offers.offerQueryParameters);
		}
		const questionnairesToShow = this.state.localQuestionnaires || this.props.questionnaires;
		const { data, isFetching } = questionnairesToShow || {};
		const tilbod = this.state.localTilbod || this.props.tilbod;
		if (!data) {
			return <></>
		}
		const questionnairesData = (!isFetching && data && data.map) ? this.sortQuestionnaires(data) : null;
		// let questionnaireslist = this.props.questionnaires;
		let customerId = this.state.customerId
		return (
			<>
				{ !isFetching && questionnairesData && tilbod &&  tilbod.contract_files && tilbod.contract_files.length === 0 ?
					<div className="row justify-content-center xs-pt-10 fill-questionnaire">
						<div className="col-12 col-sm-10 col-md-8">
							<div className="row justify-content-center xs-pt-10 step">
								<div className="tabs-container">
									<div className="accordion">

									{questionnairesData.map((questionnaire, questionnaireIndex) =>
										<div key={`questionnaire-${questionnaireIndex}`}> 
										<p className="content-title group-heading collapsed no-cursor" data-toggle="collapse">
											{questionnaire.title}
										</p>
										{ questionnaire.header ? 
											<div dangerouslySetInnerHTML={{ __html:questionnaire.header.replace(/(?:\r\n|\r|\n)/g, '<br>')}}></div> : 
										''}
										{ questionnaire.questions && questionnaire.questions.map((questionGroup, questionGroupIndex) => 
                                            questionGroup.value.question_groups[0].questions[0].type === 'text_block' ?
                                            <div key={`text-block-${questionnaireIndex}-${questionGroupIndex}`} className="text-block" dangerouslySetInnerHTML={{ __html: questionGroup.value.question_groups[0].questions[0].value.text_block.replace(/(?:\r\n|\r|\n)/g, '<br>') }}></div>
                                            :
											<Card key={`card-${questionnaireIndex}-${questionGroupIndex}`} className={"checked"}>
												<Card.Header>
													<Accordion.Toggle as={Button} variant="link" eventKey={`${customerId}-${questionnaireIndex}-${questionGroupIndex}`} onClick={(e) => this.onButtonClick(`${customerId}-${questionnaireIndex}-${questionGroupIndex}`, e)} className="toggle-button">
                                                        <span></span>
														{ questionGroup.value.title }
														<span className="arrow-toggle-button">
															{this.state.toggledAccordions[`${customerId}-${questionnaireIndex}-${questionGroupIndex}`] ? (
																<SvgArrowIcon direction="down" />
															) : (
																<SvgArrowIcon direction="up" />
															)}
                                                        </span>					
													</Accordion.Toggle>
												</Card.Header>
												<Accordion.Collapse className={"henlo tab-content"}>
													<Card.Body>
														<QuestionnaireTemplate store={store} questions={questionGroup.value.question_groups[0].questions} questionnaireId={questionnaire.id} customerId={customerId}></QuestionnaireTemplate>
													</Card.Body>
												</Accordion.Collapse>
											</Card>
										)}
										</div>
									)}

									</div>

								</div>
							</div>
						</div>
					</div>
					:
					<div className="row justify-content-center xs-pt-10 fill-questionnaire">
						<div className="col-12 col-sm-10 col-md-8 m-5">
							<div className="alert alert-info">
								{this.haveContractFileMessage(this.props.tilbod.all_signed,this.state.signingStep)}
							</div>
						</div>
					</div>
				}
				{  tilbod &&  tilbod.contract_files && tilbod.contract_files.length === 0 ?
					<div className="col-12 text-center button-container mb-5">
						{CORRECT_STEP_ORDER ? 
							<a  className="back-btn btn btn-primary xs-m-10" onClick={() => this.goBack()} >{this.backwardButtonText()}</a>
						: <></>}
						<button onClick={() => this.submitData(false,false)} className="next-btn btn btn-primary xs-m-10" disabled={this.state.disabled}>Vista svör {isFetching && <Spinner />}</button>
						{ tilbod.jsondata.additionalQuestions.contractId != '' ? 
						<button onClick={() => this.submitData(false,true)} className="next-btn btn btn-primary xs-m-10" disabled={this.state.disabled}>Senda inn svör og hefja undirritun {isFetching && <Spinner />}</button>
						:  
						<></>
						}						
					</div>
				:
					<div className="col-12 text-center button-container mb-5">
						{CORRECT_STEP_ORDER ? 
							<a  className="back-btn btn btn-primary xs-m-10" onClick={() => this.goBack()} >{this.backwardButtonText()}</a>
						: <></>}
						{!this.props.tilbod.all_signed?(
						this.state.selectedQuestionnaire?
						<a className="btn btn-primary" to={`/sign/${this.props.tilbod.token}`} onClick={() => $(`#${this.props.modalId}`).modal('hide')}>
							Undirrita rafrænt
						</a>
						:
						<Link className="btn btn-primary" to={`/sign/${this.props.tilbod.token}`} onClick={() => $(`#${this.props.modalId}`).modal('hide')}>
							Undirrita rafrænt
						</Link>)
						:<></>
						}
					</div>
				}
				{this.props.admins &&  this.props.admins.data && !this.props.tilbod.all_signed &&
				<div className="row justify-content-center text-center xs-pt-10 xs-pb-10">
					<div className="col-12 col-sm-10 col-md-8">
						<h5>Útfyllingarslóð fyrir viðskiptavin
							{this.props.createdAt &&
								<>
									(opin til {moment.utc(this.props.createdAt).add(10, 'days').format("D.M.YYYY")})
								</>
							}</h5>
						<textarea
							id="customer-signing-url"
							readOnly 
							className="linkbox col-12 justify-content-center" 
							value={window.location.href}></textarea>
						<button className="btn btn-primary" onClick={this.clippy} >{this.state.copied && <SvgCheckIcon />} Afrita</button>
					</div>
				</div>
				}
				{
					tilbod.jsondata.additionalQuestions && tilbod.jsondata.additionalQuestions.contractId != ''?
						<SigningModal title={this.state.aqModalTitle} id={"SigningModal-local"} signingUrl={this.state.aqModalSigningUrl} />
					: <></>
				}				
			</>
		)
	}
}

FillQuestionnaire.defaultProps = {
}

function mapStateToProps(state) {

	var f = {
		customers: {},
		offers: {},
		gui: {},
		nationalRegistry: {},
		infoCollection: {},
		virtualCard: {},
		healthQuestions: {},
		questionnaires: {},
		tilbod: {},
		signingModals: {},
		currentStep: null 
	}
	f.customers = (state.customers === undefined) ? {} : state.customers
	f.offers = (state.offers === undefined) ? {} : state.offers
	f.gui = (state.gui === undefined) ? {} : state.gui
	f.nationalRegistry = (state.nationalRegistry === undefined) ? {} : state.nationalRegistry
	f.infoCollection = (state.infoCollection === undefined) ? {} : state.infoCollection
	f.virtualCard = (state.virtualCard === undefined) ? {} : state.virtualCard
	f.healthQuestions = (state.healthQuestions === undefined) ? {} : state.healthQuestions
	f.questionnaires = (state.questionnaires === undefined) ? {} : state.questionnaires
	f.tilbod = (state.tilbod === undefined) ? {} : state.tilbod
	f.admins = (state.admins === undefined) ? {} : state.admins
	f.brokers = (state.brokers === undefined) ? {} : state.brokers
	f.signingModals = (state.gui && state.gui.signingModals) ? state.gui.signingModals : {};
	f.currentStep = (state.gui && state.gui.currentStep) ? state.gui.currentStep : {};
	return f;
}

export default connectWithStore(store, FillQuestionnaire, mapStateToProps);
